import {BUTTON_COLOR, BUTTON_STYLE} from '../../../constants';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import RadioButton from '../../../components/new-ui/radio_button';
import Button from '../../../forecast-app/shared/components/buttons/button/button';
import DropdownV2 from '../../../forecast-app/shared/components/dropdowns/dropdown';

export const PlanSection = props => {
	const {
		jiraEnabled,
		minimumSeats,
		minimumVirtualSeats,
		users,
		virtualUsers,
		currencies,
		billing,
		currency,
		isOnboarding,
		seats,
		virtualSeats,
		term,
		selectedTier,
		selectBilling,
		selectTerm,
		selectPlan,
		selectCurrency,
		handleOnboardingCheck,
		handleFieldChange,
		validateSeats,
		validateVirtualSeats,
		getPlansWithBillingCycle,
		plans,
		onboarding,
		currencySymbol,
	} = props;
	const planDisabled = {
		light: jiraEnabled || !plans.some(plan => plan.chargebeeId.includes('_lite_') && plan.currency === currency),
		pro: !plans.some(plan => plan.chargebeeId.includes('_pro_') && plan.currency === currency),
		enterprise: !plans.some(plan => plan.chargebeeId.includes('_enterprise_') && plan.currency === currency),
	};

	const availablePlans = plans.filter(plan => plan.chargebeeId.includes(selectedTier.toLowerCase()) && plan.currency === currency);

	let onboardingPrice = 0;
	if (selectedTier === 'PRO' || selectedTier === 'ENTERPRISE') {
		if (currency === 'DKK') {
			onboardingPrice = 15000;
		} else {
			onboardingPrice = 1999;
		}
	} else {
		if (currency === 'DKK') {
			onboardingPrice = 7500;
		} else {
			onboardingPrice = 999;
		}
	}

	return (
		<div className={'options'}>
			<div className={'plan-header'}>
				<FormattedMessage id="licensing.your_plan" />
			</div>
			<div className={'plan-top-content'}>
				<div className={'plan-select'}>
					<div className="plan-option" onClick={() => (planDisabled.light ? null : selectPlan('LITE'))}>
						<RadioButton useOnclick={true} stateValue={selectedTier} value={'LITE'} onSelected={() => (planDisabled.light ? null : selectPlan('LITE'))} cy={'select-plan-radio-lite'} locked={planDisabled.light} />
						<div className={'radio-option-label'}>
							<FormattedMessage id="common.lite_plan" />
						</div>
						{jiraEnabled ? (
							<span className="jira-warning">
								*
								<FormattedMessage id="select_plan.jira-error-message" />
							</span>
						) : (
							''
						)}
					</div>
					<div className={'plan-option'} onClick={() => (planDisabled.pro ? null : selectPlan('PRO'))}>
						<RadioButton useOnclick={true} stateValue={selectedTier} value={'PRO'} onSelected={() => (planDisabled.pro ? null : selectPlan('PRO'))} cy={'select-plan-radio-pro'} locked={planDisabled.pro} />
						<div className={'radio-option-label'}>
							<FormattedMessage id="common.pro_plan" />
						</div>
					</div>
					<div className={'plan-option'} onClick={() => (planDisabled.enterprise ? null : selectPlan('ENTERPRISE'))}>
						<RadioButton
							useOnclick={false}
							stateValue={selectedTier}
							value={'ENTERPRISE'}
							onSelected={() => (planDisabled.enterprise ? null : selectPlan('ENTERPRISE'))}
							cy={'select-plan-radio-enterprise'}
							locked={planDisabled.enterprise}
						/>
						<div className={'radio-option-label'}>
							<FormattedMessage id="common.enterprise_plan" />
						</div>
					</div>
				</div>
				<div className="billing-select">
					<Button
						colorTheme={billing === 'month' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={getPlansWithBillingCycle('month', availablePlans).length === 0}
						text={<FormattedMessage id="settings_subscription.billed-monthly" />}
						onClick={selectBilling.bind(this, 'month')}
					/>
					<Button
						colorTheme={billing === 'quarter' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={getPlansWithBillingCycle('quarter', availablePlans).length === 0}
						text={<FormattedMessage id="settings_subscription.billed-quarterly" />}
						onClick={selectBilling.bind(this, 'quarter')}
					/>
					<Button
						colorTheme={billing === 'biannual' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={getPlansWithBillingCycle('biannual', availablePlans).length === 0}
						text={<FormattedMessage id="settings_subscription.billed-biannual" />}
						onClick={selectBilling.bind(this, 'biannual')}
					/>
					<Button
						colorTheme={billing === 'annual' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={getPlansWithBillingCycle('annual', availablePlans).length === 0}
						text={<FormattedMessage id="settings_subscription.billed-annually" />}
						onClick={selectBilling.bind(this, 'annual')}
					/>
				</div>
				<div className="term-select">
					<Button
						colorTheme={term === 'Monthly' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={billing !== 'month'}
						text={<FormattedMessage id="settings_subscription.term-monthly" />}
						onClick={selectTerm.bind(this, 'Monthly')}
					/>
					<Button
						colorTheme={term === 'Quarterly' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={billing === 'annual' || billing === 'biannual' || selectedTier === 'ENTERPRISE'}
						text={<FormattedMessage id="settings_subscription.term-quarterly" />}
						onClick={selectTerm.bind(this, 'Quarterly')}
					/>
					<Button
						colorTheme={term === 'Biannual' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={billing !== 'quarter' && billing !== 'biannual'}
						text={<FormattedMessage id="settings_subscription.term-six_months" />}
						onClick={selectTerm.bind(this, 'Biannual')}
					/>
					<Button
						colorTheme={term === '1 Year' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						text={<FormattedMessage id="settings_subscription.term-annually" />}
						onClick={selectTerm.bind(this, '1 Year')}
					/>
					<Button
						colorTheme={term === '2 Years' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={billing === 'month'}
						text={<FormattedMessage id="settings_subscription.term-two_years" />}
						onClick={selectTerm.bind(this, '2 Years')}
					/>
					<Button
						colorTheme={term === '3 Years' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.FADEDGREY}
						buttonStyle={BUTTON_STYLE.FILLED}
						isDisabled={billing === 'month'}
						text={<FormattedMessage id="settings_subscription.term-three_years" />}
						onClick={selectTerm.bind(this, '3 Years')}
					/>
				</div>
			</div>
			<div className={'plan-bottom-content'}>
				<div className={'left-section'}>
					<div className="currency-select">
						<DropdownV2 value={currency} options={currencies} label={'Currency'} onChange={selectCurrency.bind(this)} />
					</div>
					{onboarding ? (
						<div className={'onboarding'}>
							<label htmlFor="use_onboarding" className="use-onboarding">
								<input type="checkbox" checked={isOnboarding} onChange={handleOnboardingCheck.bind(this)} id={'use_onboarding'} />
								<FormattedMessage id="trial_upgrade.onboarding" values={{value: onboardingPrice, currencySymbol: currencySymbol}} />
							</label>
						</div>
					) : null}
				</div>
				<div className={'right-section'}>
					<div className="user-section-header">
						<FormattedMessage id="settings_subscription.users" />
					</div>
					<div className={'user-section'}>
						<div className={'users'}>
							<label htmlFor="users">
								<div className="seat-wrapper">
									<p className={'amount-text'}>
										<FormattedMessage id="trial_upgrade.current_users_amount" />:{' '}
									</p>
									<p className={'amount-number'}>{users}</p>
								</div>
								<div className="seat-wrapper">
									<p className={'amount-text'}>
										<b>
											<span>
												<FormattedMessage id="trial_upgrade.seats_amount" />:
											</span>
										</b>
									</p>
									<input
										type="number"
										id="company_seats"
										className={!validateSeats(users, seats, minimumSeats) ? 'invalid' : ''}
										size="35"
										value={seats}
										min={users}
										placeholder={0}
										onChange={handleFieldChange.bind(this, 'seats')}
										data-cy={'seats-input'}
									/>
								</div>
								<div className="invalid-seats" data-cy={'seats-error'}>
									{seats < minimumSeats ? (
										<span>
											<FormattedMessage id="company_details.less_seats_than_plan_error" values={{amount: minimumSeats}} />
										</span>
									) : seats < users ? (
										<span>
											<FormattedMessage id="company_details.less_seats_than_users_error" />
										</span>
									) : (
										' '
									)}
								</div>
							</label>
						</div>
						<div className={'virtual-users'}>
							<label htmlFor="virtual-users">
								<div className="seat-wrapper">
									<p className={'amount-text'}>
										<FormattedMessage id="trial_upgrade.current_virtual_users_amount" />:
									</p>
									<p className={'amount-number'}>{virtualUsers}</p>
								</div>
								<div className="seat-wrapper">
									<p className={'amount-text'}>
										<b>
											<span>
												<FormattedMessage id="trial_upgrade.virtual_seats_amount" />:
											</span>
										</b>
									</p>
									<input
										type="number"
										id="company_virtual_seats"
										className={!validateVirtualSeats(virtualUsers, virtualSeats, minimumVirtualSeats) ? 'invalid' : ''}
										size="35"
										value={virtualSeats}
										min={virtualUsers}
										placeholder={0}
										onChange={handleFieldChange.bind(this, 'virtualSeats')}
										data-cy={'virtual-seats-input'}
									/>
								</div>
								<div className="invalid-seats" data-cy={'seats-error'}>
									{virtualSeats < minimumVirtualSeats ? (
										<span>
											<FormattedMessage id="company_details.less_virtual_seats_than_plan_error" values={{amount: minimumVirtualSeats}} />
										</span>
									) : virtualSeats < virtualUsers ? (
										<span>
											<FormattedMessage id="company_details.less_seats_than_virtual_users_error" />
										</span>
									) : (
										' '
									)}
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
